class QuantityDropdown extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const dropdownSelect = this.querySelector('.dropdown-select');
    const dropdownList = this.querySelector('.dropdown-list');
    const dropdownItems = dropdownList.querySelectorAll('li');
    const quantityInput = dropdownSelect.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    const previousValue = quantityInput.value;

    dropdownSelect.addEventListener('click', (event) => {
      event.stopPropagation();

      // Cierra otros dropdowns antes de abrir el actual
      document.querySelectorAll('.dropdown').forEach(dropdown => {
        if (dropdown !== this) {
          dropdown.classList.remove('active');
        }
      });

      this.classList.toggle('active');
    });

    dropdownItems.forEach((item) => {
      item.addEventListener('click', () => {
        quantityInput.value = item.textContent;
        this.classList.remove('active');
        if (previousValue !== quantityInput.value)
          quantityInput.dispatchEvent(this.changeEvent);
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.classList.remove('active');
      }
    });
  }
}

if (!customElements.get('quantity-dropdown')) {
  customElements.define('quantity-dropdown', QuantityDropdown);
}